import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const couponAPI = axios.create({
  baseURL: `${API_BASE_URL}/coupon`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: { 'Content-Type': 'application/json' },
});

export const couponService = {
  // Valida un cupón y, si pasás el monto, devuelve el descuento aplicable.
  // Respuesta: { valid, message?, code?, discountType?, discountValue?, discountAmount?, remainingUses? }
  validate: async (code, amount) => {
    const params = {};
    if (amount != null) params.amount = amount;
    const response = await couponAPI.get(`/validate/${encodeURIComponent(code)}`, { params });
    return response.data;
  },
};

export default couponService;
